
$(document).scroll(function () {
    if (!$('.itemlist').length) {
        return
    }
    var topScroll = jQuery(window).scrollTop();
    let inner = window.innerHeight;
    if ($('.itemlist').offset().top - topScroll <= inner) {
        $('.projectitem').addClass('animation-scale-up')
    }
})


//////////////////
// WEBPACK FOOTER
// ./utils/home.js
// module id = CouE
// module chunks = 1